module.exports = __webpack_public_path__ + "static/media/C-sharp-7ths.a1d6db35.png";